export default __webpack_public_path__ + "static/media/golf-cart.5dd74b01.gif";